import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=25ae0151&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ae0151",
  null
  
)

export default component.exports